module.exports = __webpack_public_path__ + "static/img/indexbg6.37b079e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/indexbg6.png
// module id = WHaX
// module chunks = 1